function setStatus(sess, id, status) {
    const { Attachment } = sess;
    if (!Attachment.idExists(id)) {
        throw new Error(`there is not AttachmentTitle with this id: '${id}'`);
    }
    Attachment.withId(id).update({
        status
    });
}

function setUploadingProgress(sess, id, progress) {
    const {Attachment} = sess;
    if (!Attachment.idExists(id)) {
        throw new Error(`there is not AttachmentTitle with this id: '${id}'`);
    }
    Attachment.withId(id).update({
        uploadingProgress: progress
    });
}

function setFilePath(sess, id, filePath) {
    const { Attachment } = sess;
    if (!Attachment.idExists(id)) {
        throw new Error(`there is not AttachmentTitle with this id: '${id}'`);
    }
    Attachment.withId(id).update({
        file: filePath,
    });
}

export default {
    setStatus,
    setUploadingProgress,
    setFilePath
}